import { createContext } from 'react';

import { DayMode } from '../../domain/routine/enums';

export interface DayModeAtmosphereValue {
  readonly dayMode: DayMode;
  readonly setDayMode: (mode: DayMode) => void;
}

export const DayModeAtmosphereContext = createContext<DayModeAtmosphereValue | undefined>(
  undefined,
);
